export const rolesAndPermissionsTheme = {
  form: {
    divider: {
      borderColor: 'palette.surface.5',
    },
    permissionHeader: {
      bg: 'palette.surface.3',
      borderRadius: '8px',
      text: 'palette.tertiary.80',
    },
    section: {
      bg: 'palette.surface.2',
    },
  },
  table: {
    accordionHeader: {
      bg: 'palette.surface.5',
      borderRadius: '8px',
      iconColor: 'palette.tertiary.40',
    },
    permissionFlag: {
      text: 'palette.neutral.95',
    },
    permissionItem: {
      borderColor: 'palette.surface.5',
    },
    permissionName: {
      text: 'palette.tertiary.50',
    },
  },
};
